// Canonical service names — shared by the simple-client services multi-select
// and the advanced-client layout row editor, so a meal type is spelled the
// same way everywhere instead of drifting into "Snacks"/"SNACKS"/"snacks".
export const SERVICE_OPTIONS = [
  "Breakfast",
  "Lunch",
  "Special Lunch",
  "Special Dinner",
  "Biryani (Veg)",
  "Biryani (Non Veg)",
  "Special Meals (Veg)",
  "Special Meals (Non Veg)",
  "Dinner",
  "Supper",
  "Snacks",
  "Tea/Coffee",
  "Juice",
  "Meal",
  "Non Veg",
  "Eggs",
  "Banana",
  "Sweets",
  "Additional Orders",
  "Special food ODC",
];